import axios from "axios";

const fetchDRDashboardData = async ({ method = "GET", url, headers = {}, params = {} }) => {
  try {
    const response = await axios({
      method,
      url,
      headers,
      params
    });
    return response;
  } catch (error) {
    console.error("Axios Error:", error);
    throw error.response ? error.response.data : error.message;
  }
};

const fetchNZData = async (url, headers = {}) => {
  try {
    const response = await fetch(url, {
      method: 'GET',
      ...headers,
    });
    const jsonData = await response.json();
    return jsonData;
  } catch (error) {
      console.error('Error fetching the JSON data:', error);
      throw error.response ? error.response.data : error.message;
  }
}

export default { fetchDRDashboardData, fetchNZData };
